<template>
<div id="app">
  <div class="custom_relation">
    <el-tabs tab-position="left">
      <el-tab-pane v-for="(item,index) in qalist" :key="index">
        <span slot="label">{{item.dissect}}</span>
        <h4>{{item.dissect}}</h4>
        <ul>
          <li v-for="(level,index2) in item.list" :key="index2">
            <p class="ques"><img src="./img/1.png" alt="" />{{level.title}}</p>
            <p class="answ"><img src="./img/2.png" alt="" /><span v-html="level.cnt"></span></p>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</div>
</template>

<script>
import util from '@/util/util.js'
import Axios from 'axios'
export default {
  data () {
    return {
        QA: [],
        qalist: [],
        api:util.config.api
    };
  },
  created(){
    this.getData()
  },
  methods: {
    getData(){
      Axios({
        params:{
          category:'3',//3 问答
          start:'0',
          count:'2000'
        },
        methods:'post',
        baseURL: this.api,
        url: '/1.0/portal/portalNews'
      }).then(res=>{
        // console.log(res)
        // this.QA = res.data.obj;
        
        // let newArr = {};
        // this.QA = this.QA.reduce((item, next) => {
        //   console.log(item,next)
        //   newArr[next.dissect] ? '' : newArr[next.dissect] = true && item.push(next);
        //   return item;
        // }, [])
        var arr =[]
        res.data.obj.forEach(item =>{
          this.QA.push(
            {dissect:item.dissect,
              list:[
                {"title":item.title,"cnt":item.cnt}
              ]
            })
        })
        // console.log(JSON.stringify(this.QA,null,2))
        var newObjArr =[];
        const obj = {}
        for(let i = 0; i < this.QA.length; i++){
        console.log(obj);
        
          if(!obj[this.QA[i].dissect]){
            newObjArr.push(this.QA[i]);
            obj[this.QA[i].dissect] = true
          }else{
            newObjArr.forEach(item =>{
              if(item.dissect == this.QA[i].dissect){
                item.list.push(this.QA[i].list[0])
              }
            })
          }
        }
        this.qalist = newObjArr;
        console.log(newObjArr)
      }).catch(error=>{
        console.log(error)
    })
    }
  }
}
</script>
<style lang="scss">

  .custom_relation{
    background: #fff;
    padding-top: 3.6458333vw;
    padding-bottom: 2.6042vw;
    h4{
      color: #333333;
      font-size: 1.25vw;
      border-bottom: 1px solid #E5E5E5;
      padding-bottom: 2.0833vw;
      font-weight: normal;
    }
    ul{
      li{
        margin-top: 2.86458333vw;
        // margin-bottom: 1.0412vw;
        p{
          img{
            margin-right: .52vw;
          }
          
        }
        .ques{
          color: #333;
          font-size: 1.0412vw;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
        }
        .answ{
          color: #666;
          font-size: .72917vw;
          margin-top: 2.34375vw;
          line-height: 1.354166vw;
          img{
            vertical-align: middle;
          }
        }
      }
    }
    .el-tabs{
      padding:0 17vw;
      /*width: 1191px;*/
      /*margin: 0 auto;*/
      .el-tabs__nav-wrap{
        width: 11.71875vw;
        background: #B1E6FF;
        border: 1px solid #99DDFD;
        padding-top: .5208333vw;
      }
      .el-tabs__item{
        text-align: center!important;
        line-height: 3.125vw;
        background: #fff;
        color: #333;
        font-size:1.0412vw;
        height: 3.125vw;
        &.is-active{
          background: #00ABFA;
          span{
            color:#fff;
          }
        }
      }
      // .el-tabs__item.
      .el-tabs__item{
        padding: 0;
      }
    }
    .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after{
      width: 0;
    }
    .el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__active-bar.is-right, .el-tabs--right .el-tabs__active-bar.is-left, .el-tabs--right .el-tabs__active-bar.is-right{
      width: 0;
    }
    .el-tabs--left .el-tabs__header.is-left{
      margin-right: 3.0208333vw;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/relation/relation.vue